import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, PanInfo } from 'framer-motion';
import { navItems } from '../../data/navigation';
import Button from '../ui/Button';

interface MobileMenuProps {
  closeMenu: () => void;
  location: ReturnType<typeof useLocation>;
}

const menuVariants = {
  hidden: {
    y: '-100%',
    transition: { type: 'tween', duration: 0.4, ease: 'easeOut' },
  },
  visible: {
    y: '0%',
    transition: { type: 'tween', duration: 0.4, ease: 'easeIn' },
  },
};

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const navListVariants = {
  visible: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
};

const navItemVariants = {
  hidden: { y: -20, opacity: 0 },
  visible: { y: 0, opacity: 1 },
};

const MobileMenu: React.FC<MobileMenuProps> = ({ closeMenu, location }) => {
  const handleDrag = (_: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    // Si on glisse vers le haut (offset.y < 0) avec une certaine vélocité, on ferme
    if (info.offset.y < -50 && info.velocity.y < -200) {
      closeMenu();
    }
  };

  return (
    <>
      {/* Fond semi-transparent */}
      <motion.div
        className="fixed inset-0 bg-neutral-background/80 z-40 xl:hidden"
        variants={overlayVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={closeMenu}
      />

      {/* Contenu du menu */}
      <motion.div
        className="fixed top-0 left-0 right-0 bg-neutral-offwhite shadow-lg rounded-b-2xl z-40 xl:hidden"
        variants={menuVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        drag="y"
        dragConstraints={{ top: 0, bottom: 0 }}
        onDragEnd={handleDrag}
        dragElastic={{ top: 0, bottom: 0.5 }}
      >
        <div className="container mx-auto px-4 pt-20 pb-8">
          <motion.div
            className="flex flex-col space-y-4"
            variants={navListVariants}
            initial="hidden"
            animate="visible"
          >
            {navItems.map((item) => (
              <motion.div key={item.path} variants={navItemVariants}>
                <Link
                  to={item.path}
                  onClick={closeMenu}
                  className={`font-nunito text-lg transition-colors duration-300 block py-2 ${
                    location.pathname === item.path
                      ? 'text-brand font-bold'
                      : 'text-neutral-body hover:text-brand'
                  }`}
                >
                  {item.label}
                </Link>
              </motion.div>
            ))}
            <motion.div variants={navItemVariants} className="pt-4">
              <Button
                variant="primary"
                size="lg"
                to="/reservation"
                className="w-full"
                onClick={closeMenu}
              >
                Prendre RDV
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </>
  );
};

export default MobileMenu;

